import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ParcelProperty } from '@core/api/angular';
import {
  DisallowedValuesPipe,
  FormatAddressPipe,
} from '@lassi/webapp-shared-pipes';

@Component({
  selector: 'lib-parcel-property-grid',
  imports: [CommonModule, DisallowedValuesPipe, FormatAddressPipe],
  template: `
    @let property = parcelProperty();
    <div class="property-section">
      <h4 class="mat-title-medium">Property {{ index() + 1 }}</h4>
      <div class="identify-grid">
        @if (property.property_lga_code | disallowedValues: ['N', null, '']) {
          <span class="mat-body-small">LGA:</span>
          <span class="mat-body-small">{{ property.property_lga_code }}</span>
        }

        @if (property.property_propnum | disallowedValues: ['N', null, '']) {
          <span class="mat-body-small">PropNum:</span>
          <span class="mat-body-small">{{ property.property_propnum }}</span>
        }

        @if (property.ezi_address | disallowedValues: ['N', null, '']) {
          <span class="mat-body-small">Address:</span>
          <span class="mat-body-small">{{
            property.ezi_address | formatAddress
          }}</span>
        }

        @if (property.property_pfi | disallowedValues: ['N', null, '']) {
          <span class="mat-body-small">PropPFI:</span>
          <span class="mat-body-small"
            >{{ property.property_pfi }}{{ parcelStatus() }}</span
          >
        }

        @if (property.property_area | disallowedValues: ['N', null, '']) {
          <span class="mat-body-small">Area:</span>
          <span class="mat-body-small"
            >{{ property.property_area | number }} m<sup>2</sup>
          </span>
        }
      </div>
    </div>
  `,
  styles: `
    @use 'shared' as *;

    @include identify-grid();

    .property-section {
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParcelPropertyGridComponent {
  parcelProperty = input.required<ParcelProperty>();
  index = input.required<number>();
  parcelStatus = input<string>('');
}
